module.exports = __webpack_public_path__ + "static/img/1-12.59a2869.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/1-12.png
// module id = LmM2
// module chunks = 0